import { render, staticRenderFns } from "./LeadSetting.vue?vue&type=template&id=46dcf370&scoped=true"
import script from "./LeadSetting.vue?vue&type=script&lang=js"
export * from "./LeadSetting.vue?vue&type=script&lang=js"
import style0 from "./LeadSetting.vue?vue&type=style&index=0&id=46dcf370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dcf370",
  null
  
)

export default component.exports